/**
 * CardEmptyState.js
 *
 * Componente padronizado para estado vazio (sem program selecionado)
 * dos cards do Executive Dashboard.
 */

import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import AssessmentOutlinedIcon from "@material-ui/icons/AssessmentOutlined";
import AuthContext from "connections/auth/AuthProvider.js";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    minHeight: (props) => props.minHeight || 180,
    maxHeight: (props) => props.minHeight || 180,
    padding: theme.spacing(2),
    boxSizing: "border-box",
  },
  icon: {
    fontSize: 36,
    color: (props) => props.clientColor || "#9e9e9e",
    marginBottom: theme.spacing(1),
    opacity: 0.5,
  },
  message: {
    color: theme.palette.text.disabled,
    textAlign: "center",
    fontSize: "0.75rem",
  },
}));

/**
 * CardEmptyState - Estado vazio padronizado (sem program selecionado)
 *
 * @param {number} minHeight - Altura mínima do container
 */
export default function CardEmptyState({ minHeight = 180 }) {
  const { userDetails } = useContext(AuthContext);
  const clientColor = userDetails?.implementation_color || "#9e9e9e";
  const classes = useStyles({ minHeight, clientColor });
  const { t } = useTranslation("translation", { keyPrefix: "rgm.executive" });

  return (
    <Box className={classes.container}>
      <AssessmentOutlinedIcon className={classes.icon} />
      <Typography className={classes.message}>
        {t("empty_state.select_program")}
      </Typography>
    </Box>
  );
}

CardEmptyState.propTypes = {
  minHeight: PropTypes.number,
};
